import { Typography } from "@material-tailwind/react";
import { Link } from "react-router-dom";
import "../styles/sortbybar.css";
 
type SortByBarProps = {
  products: any;
  filteredProducts: any;
  setFilteredProducts: (filteredProducts: any) => void;
};

export function SortByBar({ products, filteredProducts, setFilteredProducts }: SortByBarProps) {

  const handleSortChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const sortType = event.target.value;
    
    let sortedProducts = [...filteredProducts];
    
    if (sortType === 'lowToHigh') {
      sortedProducts.sort((a, b) => a.price - b.price);
    } else if (sortType === 'highToLow') {
      sortedProducts.sort((a, b) => b.price - a.price);
    } else if (sortType === 'newness') {
      sortedProducts.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
    }
    
    setFilteredProducts(sortedProducts);
  };

  return (
    <div className="sort-by-bar">
      <div>Hiển thị {filteredProducts.length} sản phẩm trong {products.length} sản phẩm</div> 
      <div className="flex gap-2 justify-between">
        <strong>Sắp xếp theo:</strong>
        <select onChange={handleSortChange}>
          <option value="newness">Mới nhất</option>
          <option value="lowToHigh">Giá: thấp đến cao</option>
          <option value="highToLow">Giá: cao đến thấp</option>
        </select>
      </div>
    </div>
  );
}
